import React, { useEffect, useState } from 'react';
import PartnerBanner from '../components/PartnerBanner'
import PartnerBenefits from '../components/PartnerBenefit'
import TelecomPartners from '../components/Partners'
import TestimonialSection from '../components/PartnerCards'
function PartnerPage () {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    // Update isMobile state on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const styles = {
    hero: {
      marginTop: isMobile ? '30px' : '-20px',
      marginBottom: isMobile ? '-40px' : '-30px',
    },
    hero2: {
      marginTop: isMobile ? '45px' : '-80px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
    hero3: {
      marginTop: isMobile ? '25px' : '20px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
  };
  return (
    <div>
      <PartnerBanner />
      <PartnerBenefits />
      <div style={styles.hero}>
      <TelecomPartners />
      </div>
      <div style={{ marginTop: '-10px' }}>
      <TestimonialSection />
      </div>
   
 
    </div>
  )
}

export default PartnerPage
